import { createSelector } from 'reselect'

import {
  eventTypeSelector,
  schedulingLinkSelector as schedulingLinkQuerySelector
} from 'root-api'
import { currentUserSelector } from 'selectors/user'

const BOOKING_METHODS = {
  instant: 'instant',
  poll: 'poll',
}

export const smsReminderEnabledSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.sms_reminder_enabled
)

export const smsLegalDisclaimerSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.sms_legal_disclaimer
)

export const isPollSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType && (eventType.booking_method === BOOKING_METHODS.poll)
)

export const isAdhocEventSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType && (eventType.type === 'AdhocEventType')
)

export const locationConfigurationsSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.location_configurations
)

export const ignoreLocationConfigurationsSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.ignore_location_configurations
)

export const confirmationPageTypeSelector = createSelector(
  eventTypeSelector,
  (eventType) => (eventType ? eventType.confirmation_page_type : null)
)

export const nextAvailabilitySelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.next_availability
)

export const lastAvailabilitySelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.last_availability
)

const externalAvailabilityProcessingTypeSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.external_availability_processing_type
)

export const canProcessRangesInParallel = (state) => externalAvailabilityProcessingTypeSelector(state) === 'parallel'

export const isEventOwnerSelector = createSelector(
  eventTypeSelector,
  currentUserSelector,
  (eventType, currentUser) => currentUser?.uuid === eventType?.owning_user?.uuid
)

const integrationsSelector = createSelector(
  eventTypeSelector,
  (eventType) => eventType.integrations
)

const mailchimpSelector = createSelector(
  integrationsSelector,
  (integrations) => integrations.mailchimp
)

export const showMailchimpInviteeConsentSelector = createSelector(
  mailchimpSelector,
  (mailchimp) => mailchimp.show_invitee_consent
)

export const schedulingLinkSelector = createSelector(
  schedulingLinkQuerySelector,
  eventTypeSelector,
  (schedulingLinkFromQuery, eventType) => schedulingLinkFromQuery || eventType?.scheduling_link
)
